// extracted by mini-css-extract-plugin
export default {"individualCard":"IndividualCard_individualCard__SHQZ3","open":"IndividualCard_open__DZjEm"};